import {NextPage} from "next";
import Head from "next/head";
import {wrapper} from "../../app/store";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {CampaignsView} from "../../components/campaign/CampaignsView";

const Campaigns: NextPage = () => {
  return <>
    <Head>
      <title>Campaigns</title>
    </Head>
    <CampaignsView />
  </>
}

export const getStaticProps = wrapper.getStaticProps(store => async ({ locale }: any) => {
  return {
    props: {
      ...await serverSideTranslations(locale, ['common', 'landing', 'auth', 'location', 'store', 'payment', 'checkout', 'order', 'affiliate']),
    }
  }
});


export default Campaigns